import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ReserveTableModal from './ReserveTableModal';
import MobileMenu from './MobileMenu';
import './Header.css';

const Header: React.FC = () => {
  const [isReserveModalOpen, setIsReserveModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="header-area header-three">
      <div id="header-sticky" className="menu-area">
        <div className="container">
          <div className="second-menu">
            <div className="row align-items-center">
              <div className="col-xl-2 col-lg-2 col-6">
                <div className="logo">
                  <Link to="/">
                    <img src="/images/logo.png" alt="logo" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-8 col-lg-8 d-none d-lg-block">
                <div className="main-menu text-center">
                  <nav id="mobile-menu">
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li className="has-sub">
                        <a href="#">Facilities</a>
                        <ul>
                          <li className="has-sub">
                            <a href="#">
                              Bar & Restaurant <i className="fa fa-angle-right"></i>
                            </a>
                            <ul>
                              <li className="has-sub">
                                <a href="#">
                                  Restaurant <i className="fa fa-angle-right"></i>
                                </a>
                                <ul>
                                  <li>
                                    <Link to="/hangout">Hangout</Link>
                                  </li>
                                  <li>
                                    <Link to="/restaurant">Restro</Link>
                                  </li>
                                  <li>
                                    <Link to="/pub">Pub</Link>
                                  </li>
                                  <li>
                                    <Link to="/celebrity-appearance">Celebrity Appearance</Link>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <Link to="/bar-and-lounge">Bar & Lounge</Link>
                              </li>
                            </ul>
                          </li>
                          <li className="has-sub">
                            <a href="#">
                              Lounge <i className="fa fa-angle-right"></i>
                            </a>
                            <ul>
                              <li>
                                <Link to="/family-lounge">Family Lounge</Link>
                              </li>
                              <li>
                                <Link to="/corporate-business-lounge">Corporate / Business Lounge</Link>
                              </li>
                            </ul>
                          </li>
                          <li className="has-sub">
                            <a href="#">
                              Club <i className="fa fa-angle-right"></i>
                            </a>
                            <ul>
                              <li>
                                <Link to="/night-club">Night Club</Link>
                              </li>
                              <li>
                                <Link to="/pub">Pub</Link>
                              </li>
                              <li>
                                <Link to="/night-life">Night life</Link>
                              </li>
                            </ul>
                          </li>
                          <li className="has-sub">
                            <a href="#">
                              Event <i className="fa fa-angle-right"></i>
                            </a>
                            <ul>
                              <li>
                                <Link to="/corporate-event">Corporate Event</Link>
                              </li>
                              <li>
                                <Link to="/family-event">Family Event</Link>
                              </li>
                              <li>
                                <Link to="/filmshoot-event">Filmshoot Event</Link>
                              </li>
                            </ul>
                          </li>
                          <li className="has-sub">
                            <a href="#">
                              Party <i className="fa fa-angle-right"></i>
                            </a>
                            <ul>
                              <li>
                                <Link to="/corporate-party">Corporate Party</Link>
                              </li>
                              <li>
                                <Link to="/filmshoot-party">Filmshoot Party</Link>
                              </li>
                              <li>
                                <Link to="/kitty-party">Kitty Party</Link>
                              </li>
                              <li>
                                <Link to="/birthday-party">Birthday Party</Link>
                              </li>
                              <li>
                                <Link to="/prewedding-shoot">Prewedding Shoot</Link>
                              </li>
                              <li>
                                <Link to="/family-parties">Family Parties</Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/menu">Menu</Link>
                      </li>
                      <li>
                        <Link to="/events-and-media">Event & media</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-xl-2 col-lg-2 d-none d-lg-block">
                <div className="header-buttons">
                  <button onClick={() => setIsReserveModalOpen(true)} className="reserve-btn" type="button">
                    <span className="reserve-icon">
                      <i className="fas fa-utensils" aria-hidden="true"></i>
                    </span>
                    <span>Reserve Table</span>
                  </button>
                  <Link to="/enquiry" className="enquiry-btn">
                    Enquiry
                  </Link>
                </div>
              </div>
              <div className="col-6 d-lg-none mobile-hamburger-col">
                <button
                  className="hamburger-btn"
                  onClick={() => setIsMobileMenuOpen(true)}
                  aria-label="Toggle menu"
                  aria-expanded={isMobileMenuOpen}
                  aria-controls="mobile-navigation"
                  type="button"
                >
                  <i className="fas fa-bars"></i>
                </button>
              </div>
              <div className="col-12 d-lg-none">
                <div className="mobile-header-actions">
                  <button onClick={() => setIsReserveModalOpen(true)} className="reserve-btn" type="button">
                    <span className="reserve-icon">
                      <i className="fas fa-utensils" aria-hidden="true"></i>
                    </span>
                    <span>Reserve Table</span>
                  </button>
                  <Link to="/enquiry" className="enquiry-btn mobile-enquiry-btn">
                    Enquiry
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReserveTableModal isOpen={isReserveModalOpen} onClose={() => setIsReserveModalOpen(false)} />
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </header>
  );
};

export default Header;
